var symphony = symphony || {};

;(function() {

	symphony.toggleMenu = function() {

		var toggle = $('.js-toggleMenu'),
			nav = $('.flyoutContainer');

		toggle.on('click', function(e){
			e.preventDefault();
			if(nav.hasClass('isVisible')){
				nav.removeClass('isVisible');
			} else {
				nav.addClass('isVisible');
			}
		});

	};


})();